<template>
  <div class="content">
    <form>
      <kirim-form :datas="dataall"></kirim-form>
      <kontragent :datas="dataall"></kontragent>
      <firma></firma>
      <sklad :datas="dataall"></sklad>
      <paytype :datas="dataall"></paytype>
    </form>

    <!-- Yangi zamonaviy modal — saqlanmagan ma'lumot ogohlantirish -->
    <div v-if="showUnsavedModal" class="usm-overlay" @click.self="cancelUnsaved">
      <div class="usm-modal">
        <div class="usm-icon">
          <b-icon icon="exclamation-triangle-fill"></b-icon>
        </div>
        <h3 class="usm-title">Saqlanmagan ma'lumotlar mavjud</h3>
        <p class="usm-text">
          Kiritilgan kirim hujjati hali saqlanmagan. Nima qilamiz?
        </p>

        <div class="usm-actions">
          <button type="button" class="usm-btn usm-save" @click="onSaveYes">
            <b-icon icon="check-circle-fill"></b-icon>
            Saqlash
          </button>
          <button type="button" class="usm-btn usm-discard" @click="onDiscard">
            <b-icon icon="trash-fill"></b-icon>
            Saqlamasdan chiqish
          </button>
          <button type="button" class="usm-btn usm-cancel" @click="cancelUnsaved">
            <b-icon icon="arrow-left"></b-icon>
            Bekor qilish
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { KirimForm, Kontragent, Firma, Sklad, Paytype } from "@/pages";
  export default {
    components: {
      KirimForm,
      Kontragent,
      Firma,
      Sklad,
      Paytype
    },
    created: function () {
      let self = this;
      axios
        .get("api/v1/prixod/last-number")
        .then(function (response) {
          self.dataall.number = response.data.number;
          self.$store.state.saved = null;
        });
      axios
        .get("api/v1/dollar-exchange-rate/last")
        .then(function (response) {
          self.dataall.dollar_rate = response.data.rate;
          self.$store.state.saved = null;
        });
    },
    watch: {
      dataall: {
        deep: true,
        handler(val, oldVal) {
          this.$store.state.saved += 1;
        }
      }
    },
    beforeMount() {
      // window.addEventListener("beforeunload", this.preventNav);
    },
    beforeRouteLeave(to, from, next) {
      this.$root.$refs.prixod.SaveSettings();
      if (this.$store.state.saved < 2) {
        this.$store.state.saved = null;
        localStorage.removeItem("prostatka");
        next();
        this.$store.state.selected_index = null;
      } else {
        // Modal'ni ko'rsatib navigatsiyani to'xtatib turamiz
        this._pendingNext = next;
        this.showUnsavedModal = true;
        // navigatsiyani bekor qilish (modal javobiga qarab keyin yo'naltiramiz)
      }
    },
    data() {
      return {
        showUnsavedModal: false,
        _pendingNext: null,
        dataall: {
          number: 0,
          dollar_rate: 0,
          sklad_id: parseInt(localStorage.getItem("sklad_id")),
          created_at: new Date()
            .valueOf()
            .toString()
            .slice(0, 10),
          updated_at: new Date()
            .valueOf()
            .toString()
            .slice(0, 10),
          kontragent_id: 0,
          debit_summa: 0,
          user_id: parseInt(localStorage.getItem("user_id")),
          pay_type_id: 1,
          rasxod_summa: 0,
          skidka_summa: 0,
          prixod_summa: 0,
          summa: 0,
          summa_som: 0,
          summa_dollar: 0,
          comment: "",
          count_all: 0,
          prixod_table: [
            {
              product_id: 0,
              current_balance: 0,
              count: 0,
              debit_price: 0,
              debit_summa: 0,
              kontragent_price: 0,
              kontragent_summa: 0,
              chakana_percent: 0.0,
              optom_percent: 0,
              chakana_price: 0,
              chakana_dollar_price: 0,
              optom_price: 0,
              optom_dollar_price: 0,
              chakana_summa: 0,
              optom_summa: 0,
              shtrix_kod: "",
              pack_count: 0,
              pack_price: 0,
              price_type: 1,
              pack_norma: 0
            }
          ]
        }
      };
    },
    methods: {
      // Modal — "Saqlash" tugmasi
      onSaveYes() {
        this.showUnsavedModal = false;
        // Save document — saqlash tugagach mostlikga keyin navigatsiya o'tadi
        if (this.$root.$refs.prixod && this.$root.$refs.prixod.Savedokument) {
          this.$root.$refs.prixod.Savedokument();
        }
        // Pending next ni rad qilamiz (savedokument o'zi navigatsiya qiladi)
        if (this._pendingNext) { this._pendingNext(false); this._pendingNext = null; }
      },
      // Modal — "Saqlamasdan chiqish"
      onDiscard() {
        this.showUnsavedModal = false;
        this.$store.state.saved = null;
        localStorage.removeItem("prostatka");
        if (this._pendingNext) { this._pendingNext(); this._pendingNext = null; }
      },
      // Modal — "Bekor qilish"
      cancelUnsaved() {
        this.showUnsavedModal = false;
        if (this._pendingNext) { this._pendingNext(false); this._pendingNext = null; }
      },

      Home() {
        this.$store.state.saved = null;
        this.showUnsavedModal = false;
        this.$router.push({ name: "Кирим" });
      }
      //   preventNav(event) {
      //     event.preventDefault();
      //     event.returnValue = "";
      //   }
    },
  };
</script>

<style scoped>
/* Saqlanmagan ma'lumot modali */
.usm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(6px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  animation: usm-fade 0.18s ease-out;
}
@keyframes usm-fade {
  from { opacity: 0; }
  to { opacity: 1; }
}

.usm-modal {
  background: white;
  border-radius: 22px;
  width: 100%;
  max-width: 460px;
  padding: 32px 26px 24px;
  text-align: center;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.25);
  animation: usm-pop 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
@keyframes usm-pop {
  0% { transform: scale(0.85); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}

.usm-icon {
  width: 72px;
  height: 72px;
  margin: 0 auto 16px;
  border-radius: 50%;
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 38px;
  color: #d97706;
  box-shadow: 0 8px 20px rgba(217, 119, 6, 0.2);
}

.usm-title {
  font-weight: 800;
  font-size: 19px;
  color: #0f172a;
  margin: 0 0 8px;
}

.usm-text {
  font-size: 14px;
  color: #64748b;
  line-height: 1.5;
  margin: 0 0 22px;
}

.usm-actions {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
}

.usm-btn {
  border: none;
  padding: 12px 18px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: 0.2s;
}
.usm-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 14px rgba(0, 0, 0, 0.12); }
.usm-btn svg { font-size: 16px; }

.usm-save {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}
.usm-save:hover { box-shadow: 0 8px 20px rgba(16, 185, 129, 0.4); }

.usm-discard {
  background: white;
  color: #e11d48;
  border: 1.5px solid #fecdd3;
}
.usm-discard:hover { background: #e11d48; color: white; border-color: #e11d48; }

.usm-cancel {
  background: #f1f5f9;
  color: #64748b;
}
.usm-cancel:hover { background: #e2e8f0; color: #0f172a; }
</style>